import WebServiceRequest from "@/libs/Api/WebServiceRequest";

class GetTimeZoneList extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Country/GetTimeZoneList");
  }
}

export { GetTimeZoneList };
